import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { baseURL } from '../api/baseURL';
import { playAlertSound } from '../utils/alertSound';

/**
 * Client-reported: "In both App & Admin, all notification - new order,
 * reminder, extension, etc ... bell ring should happen." Mounted once,
 * globally, in AdminShell so it's active on every page — polls for the
 * single most recent order and rings the alert tone the moment a genuinely
 * new one appears, not just when someone happens to be looking at the
 * Orders tab.
 */
class NewOrderAlertSound extends React.Component<{ token?: string }> {
    pollTimer: ReturnType<typeof setInterval> | null = null;
    lastReceiptId: string | null = null;
    hasFetchedOnce = false;

    componentDidMount(): void {
        this.poll();
        this.pollTimer = setInterval(() => this.poll(), 30000);
    }

    componentWillUnmount(): void {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }

    poll = (): void => {
        const token = this.props.token;
        if (!token) return;
        axios.get(`${baseURL}/orders?page=1&limit=1`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response: any) => {
                const latest = response?.data?.orders?.[0];
                const receiptId = latest?.receipt_id || null;
                if (!receiptId) return;
                // Never ring on the very first poll (that's just "here's what
                // was already the most recent order before this tab opened"),
                // only when it actually changes to something new after that.
                if (this.hasFetchedOnce && this.lastReceiptId && receiptId !== this.lastReceiptId) {
                    playAlertSound();
                }
                this.hasFetchedOnce = true;
                this.lastReceiptId = receiptId;
            })
            .catch(() => {});
    };

    render(): React.ReactNode {
        return null;
    }
}

const mapStateToProps = (state: any) => ({
    token: state.auth?.token,
});

export default connect(mapStateToProps)(NewOrderAlertSound);
